import { useEffect, useState } from "react";
import {
	isAndroid,
	isIOS,
	isMobile,
	isTablet,
	mobileModel,
	mobileVendor,
} from "react-device-detect";
import { compatibleModel, compatibleVender } from "./eSIMcompatibleDeviceList";

export default function useDeviceDetect() {
	const [isEsimCompatible, setEsimCompatible] = useState<boolean | null>(false);

	useEffect(() => {
		const checkCompatible = () => {
			if (
				compatibleVender.includes(mobileVendor) &&
				compatibleModel.includes(mobileModel)
			)
				setEsimCompatible(true);
			else setEsimCompatible(false);
		};

		if (isIOS && !isTablet) {
			setEsimCompatible(null);
		} else if (isAndroid) {
			checkCompatible();
		} else {
			setEsimCompatible(false);
		}
		if (!isMobile) {
			setEsimCompatible(false);
		}
		if (isTablet) {
			setEsimCompatible(false);
		}
	}, []);

	return {
		isMobile,
		isTablet,
		isEsimCompatible,
		isAndroid,
		isIOS,
	};
}
